export const environment = {
  BASE_URL_API: "https://nre.neelaps.app/v1.0"
};
